
import { defineComponent } from "vue";
import InformativeIcon from "@/components/icons/InformativeIcon.vue";

interface ToolTipData {
  isVisible: boolean;
}

export default defineComponent({
  data(): ToolTipData {
    return {
      isVisible: false,
    };
  },
  methods: {
    toggle() {
      console.log("toggle");
      this.isVisible = !this.isVisible;
    },
    show() {
      console.log("show");
      this.isVisible = true;
    },
    hide() {
      console.log("hide");
      this.isVisible = false;
    },
  },
  components: { InformativeIcon },
});
